// extracted by mini-css-extract-plugin
export default {"row":"InrDefaultDeposit_row__Mc9M6","icon":"InrDefaultDeposit_icon__bwkbj","text":"InrDefaultDeposit_text__Uj-Sp"};